import { render, staticRenderFns } from "./moreVideo.vue?vue&type=template&id=6394ac79&scoped=true&"
import script from "./moreVideo.vue?vue&type=script&lang=js&"
export * from "./moreVideo.vue?vue&type=script&lang=js&"
import style0 from "./moreVideo.vue?vue&type=style&index=0&id=6394ac79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6394ac79",
  null
  
)

export default component.exports